import React, { Component } from 'react';
import { Button, DialogContainer, TextField, Toolbar } from 'react-md';
import { Item } from '../models/Item';
import { formatCurrency, formatQuantidade } from '../common/formaters';
import { clearDigitsSpecialChars } from '../common/parsers';
 
class EstoqueForm extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            estoque: null
        }
    }


    render() {
        const { visible, model, pageX, pageY } = this.props;
        const { estoque } = this.state;


        return (
            <DialogContainer id="modal-form" visible={visible} pageX={pageX} pageY={pageY}
                fullPage onHide={this.hide} aria-labelledby="modal-form-title">
                <form onSubmit={this.handleSave}>
                    <Toolbar fixed colored title="Item" titleId="modal-form-title" 
                        nav={<Button icon onClick={this.hide}>close</Button>}
                        actions={<Button type="submit" raised className="btn btn-primary" iconChildren="check">Salvar</Button>}/>
                    <section className="md-toolbar-relative">
                        <div className="md-cell--center md-cell--6">
                            <TextField id="form-item-quantidade" label="Entrada no estoque" lineDirection="center" required
                                onChange={this.updateEstoque} value={formatQuantidade(estoque)} className="md-cell md-cell--bottom md-cell--12" placeholder="Digite a quantidade a ser adicionada" 
                                />
                        </div>
                        <br/>
                        <div className="md-cell--center md-cell--6">
                            <TextField id="form-item-id" label="Código" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12"
                                 value={model.id} disabled={this.props.model.id? true:false}/>

                            <TextField id="form-item-descricao" label="Descrição" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite a descrição do item" 
                                value={model.nome} disabled={this.props.model.id? true:false}/>

                            <TextField id="form-item-quantidade" label="Quantidade atual" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite a quantidade em estoque" 
                                value={formatQuantidade(model.quantidade)} disabled={this.props.model.id? true:false}/>
                            
                            <TextField id="form-item-custo" label="Custo" lineDirection="center" required
                                className="md-cell md-cell--bottom md-cell--12" placeholder="Digite o custo do item" 
                                value={model.custo_unitario} disabled={this.props.model.id? true:false}/>
                        </div>
                    </section>
                </form>
            </DialogContainer>
        )
    }

    hide = () => {
        this.props.onHide();
    }

    handleSave = event => {
        event.preventDefault();
        this.handleChange()

        let model = new Item(this.props.model);
        this.props.onSave(model);
    }

    handleChange = () => {
        let model = this.props.model;

        let antigoEstoque = this.props.model.quantidade;
        let estoque = Number(this.state.estoque);

        model['quantidade'] = antigoEstoque + estoque
        this.props.onChange(model);
    }

    updateEstoque = value => {
        const re = /^\d+(.\d+)*$/;

        if (value === '' || re.test(value)) {
            this.setState({estoque: clearDigitsSpecialChars(value)})
        }
    }

}

export default EstoqueForm;


// WEBPACK FOOTER //
// ./src/forms/EstoqueForm.js